
define('modules/application/wizard/classes/radioSystems',[
    "app",

    // Libs
    "backbone",

    //Classes
    "./genericElement"

  ],

  function(app, Backbone, genericElement) {

    var radioSystemModel = Backbone.Model.extend({
      defaults: {
        minValue: 0,
        value: 0
      },
      initialize: function() {

        this.unbind("change:value", this.valueChangedEventHandler);
        this.bind("change:value", this.valueChangedEventHandler, this);

        if (!this.get("value"))
          this.set("value", 0);
      },
      decrementValue: function() {
        if (this.get("enabled") === true) {
          var currentValue = this.get("value");
          if(!this.get("sectionEventAggregator").countExpansion)
            this.get("sectionEventAggregator").countExpansion=1;
          if (currentValue - 1 >= this.get("minValue")) {
            this.set("value", (currentValue - 1));
            if(this.get('type')=='interfaces'){
              this.get("sectionEventAggregator").countExpansion=this.get("sectionEventAggregator").countExpansion-1;
              this.get("sectionEventAggregator").trigger("verifyRemotes");
            }
          }
        }
      },
      incrementValue: function() {
        // controllare nell'aggiunta che i remotes siano al massimo le interfaces*10 (maxValue di remotes)
        if (this.get("enabled") === true) {
          var currentValue = this.get("value");
          if(!this.get("sectionEventAggregator").countExpansion)
            this.get("sectionEventAggregator").countExpansion=1;
          if(this.get('type')=='interfaces'){
            if (currentValue + 1 <= this.get("maxValue")) {
              this.get("sectionEventAggregator").countExpansion=this.get("sectionEventAggregator").countExpansion+1;
              this.set("value", (currentValue + 1));
            }
          }else
            if(currentValue + 1<= this.get("sectionEventAggregator").countExpansion*this.get("maxValue"))
              this.set("value", (currentValue + 1));
        }
      },
      enable: function() {
        if (!this.get("enabled")) {
          this.set("enabled", true);
          this.set("value", this.get("minValue"));
          this.trigger("updateView");
        }
      },
      disable: function() {
        if (this.get("enabled")) {
          this.set("enabled", false);
          this.set("value", 0);
          this.trigger("updateView");
        }
      },
      valueChangedEventHandler: function() {
        this.trigger("value:changed");
        this.get("sectionEventAggregator").trigger("value:changed");
      }
    });

    var radioSystemView = Backbone.View.extend({
      template: "application/wizard/sections/radioSystem/item",
      className: "radioSystem",
      events: {
        "click .ui-spinner-down": "decrementValue",
        "click .ui-spinner-up": "incrementValue",
        "click .toggleInfoButton": "toggleInfos"
      },
      serialize: function() {

        return {
          model: this.model,
          app: app
        };
      },
      initialize: function() {
        this.model.unbind("value:changed", this.updateSpinners);
        this.model.bind("value:changed", this.updateSpinners, this);

        this.model.unbind("updateView", this.render);
        this.model.bind("updateView", this.render, this);
      },

      toggleInfos: function(e) {
        var that = this;
        e.preventDefault();

        if (window.isBrowserCompatibleWithAnimation())
          that.$el.find(".arrow-info").transition({
            rotate: "+=180"
          });
        else {
          if (this.$el.find(".tooltip:visible").length > 0)
            that.$el.find(".arrow-info").attr("src", "/assets/img/info-arrow-down.png");
          else
            that.$el.find(".arrow-info").attr("src", "/assets/img/info-arrow-up.png");
        }

        if (this.$el.find(".tooltip:visible").length === 0)
          that.$el.find("hr").toggle();

        this.$el.find(".tooltip").slideToggle(function() {
          if (that.$el.find(".tooltip:visible").length === 0) that.$el.find("hr").toggle();
        });
        return false;
      },

      infoButtonClickedEventHandler: function(e) {
        e.preventDefault();
        e.stopPropagation();
        this.toggleTooltips();
      },

      decrementValue: function() {
        this.model.decrementValue();
      },
      incrementValue: function() {
        this.model.incrementValue();
      },
      updateSpinners: function() {
        this.$el.find(".mainValue .spinner").html(this.model.get("value"));
      },
      afterRender: function() {

      }
    });

    var radioSystems = _.extend({}, genericElement, {

      Views: {

        titleBar: genericElement.Views.titleBar.extend({

          template: "application/wizard/sections/radioSystem/titleBar",
          tagName: "h3",

          initialize: function() {
            this.model.unbind("updateViews", this.setLabel);
            this.model.bind("updateViews", this.setLabel, this);
            this.model.set("titleBarView", this);
          },

          setLabel: function(amounts) {
            var amountsLength = amounts.length;
            var stringToOutput = "";
            if (!this.model.get("unavailable"))
              for (var i = 0; i < amountsLength; i++) {
                if (amounts[i].amount > 0) {
                  if (i > 0)
                    stringToOutput += " - ";
                  stringToOutput += amounts[i].amount + " " + $.i18n._(amounts[i].name);
                }
              }

            if (stringToOutput !== "") {
              this.$el.find(".caption").html(stringToOutput);
              this.$el.find(".caption").fadeIn(200);
            } else
              this.$el.find(".caption").fadeOut(200, function() {
                $(this).hide();
              });
          },

          enable: function() {
            this.$el.trigger("click");
            this.$el.find(".caption").fadeIn(200);
          },

          disable: function() {
            this.$el.trigger("click");
            this.$el.find(".caption").fadeOut(200, function() {
              $(this).hide();
            });
          },

          removeLabel: function() {
            this.$el.find(".caption").fadeOut(200, function() {
              $(this).hide();
            });
          },

          onClose: function() {
            this.model.unbind("updateViews", this.setLabel);
          }
        }),

        content: genericElement.Views.content.extend({
          template: "application/wizard/sections/radioSystem/content",
          className: "radioSystems",
          events: {
            "click .radio": "enabledSelectorChangedEventHandler"
          },

          initialize: function() {
            this.renderRequestedEventHandler();
            this.model.set("contentView", this);

            this.model.unbind("updateViews", this.setupAbilitation);
            this.model.bind("updateViews", this.setupAbilitation, this);

            this.model.unbind('render:requested', this.renderRequestedEventHandler);
            this.model.bind('render:requested', this.renderRequestedEventHandler, this);

          },

          renderRequestedEventHandler: function() {
            var i = 0,
              remoteControlsLength;
            var subViews = this.getViews().__wrapped__;
            for (i = 0; i < subViews.length; i++)
              subViews[i].remove();

            if (!this.model.get("unavailable")) {
              this.$el.find(".alert").hide();
              this.$el.find(".remotesType").show();
              var interfaces = this.model.get("interfaces");
              remoteControlsLength = interfaces ? interfaces.length : 0;
              for (i = 0; i < remoteControlsLength; i++)
                this.insertView(new radioSystemView({
                  model: interfaces[i]
                })).render();

              var remoteControls = this.model.get("remotes");
              remoteControlsLength = remoteControls ? remoteControls.length : 0;
              for (i = 0; i < remoteControlsLength; i++)
                this.insertView(new radioSystemView({
                  model: remoteControls[i]
                })).render();
            } else {
              this.$el.find(".alert").show();
              this.$el.find(".remotesType").hide();
            }
          },

          setupAbilitation: function() {
            var interfacesModel = this.model.get("interfaces");
            if (interfacesModel) {
              this.$el.find("input").removeAttr("checked");
              if (interfacesModel[0].get("enabled")) {
                this.$el.find("input[value='1']").attr('checked', true);
              } else {
                this.$el.find("input[value='0']").attr('checked', true);
              }

              this.$el.find("input").removeAttr("rel");
              this.$el.find(".radio").remove();
              window.customizeFormElements.call();
            }
          },

          serialize: function() {
            return {
              model: this.model,
              app: app
            };
          },

          enabledSelectorChangedEventHandler: function(e) {
            var value = this.$el.find("input[name='enabled']:checked") ? this.$el.find("input[name='enabled']:checked").val() : (this.model.get("enabled") ? 1 :0);
            if (value === "1") {
              this.model.enableInterfaces();
              this.model.enableRemotes();
              BticinoS4B.Instances.Models.ApplicationModel.set("radioSystemPresent", true);
              window.BticinoS4B.eventAggregator.trigger("radioSystemPresent:changed", this);
            } else {
              this.model.disableRemotes();
              this.model.disableInterfaces();
              BticinoS4B.Instances.Models.ApplicationModel.set("radioSystemPresent", false);
              window.BticinoS4B.eventAggregator.trigger("radioSystemPresent:changed", this);
            }
            this.renderRequestedEventHandler();
          },

          decrementValue: function() {
            if (this.model.get("enabled"))
              this.model.decrementValue();
          },

          incrementValue: function() {
            if (this.model.get("enabled"))
              this.model.incrementValue();
          },

          disableSection: function() {
            if (!this.model.get("enabled"))
              this.$el.find(".mainValue").addClass("disabled");
          },

          enableSection: function() {
            if (this.model.get("enabled"))
              this.$el.find(".mainValue").removeClass("disabled");
          },

          isOpen: function() {
            return this.$el.css("display") == "block";
          },

          //Retrieve and set the accessory line's details
          afterRender: function() {
            this.$el.find("h4.mainTitle").html($.i18n._(this.model.get("wizardChoiceLabel")));

            setTimeout(function() {
              if (this.tooltip && this.tooltip.qtip('api')) this.tooltip.qtip('api').reposition();
            }, 200);
            window.customizeFormElements.call();
          },

          onClose: function() {
            this.model.unbind("updateViews", this.setLabel);
          }
        })
      },

      Model: genericElement.Model.extend({

        defaults: _.extend({
          unavailable: false
        }, genericElement.Model.prototype.defaults),

        initialize: function() {
          var that = this;
          this.set("sectionEventAggregator", _.extend({}, Backbone.Events));

          //Bind on accessory line selection
          window.BticinoS4B.eventAggregator.unbind('accessoryLine:chosen', this.retrievePackages);
          window.BticinoS4B.eventAggregator.bind('accessoryLine:chosen', this.retrievePackages, this);

          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          //Bind on materials overview model delivery request
          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          this.unbind("change:loadedModel", this.changeLoadedModelEventHandler);
          this.bind("change:loadedModel", this.changeLoadedModelEventHandler, this);

          this.get("sectionEventAggregator").unbind("value:changed", this.valueChangedEventHandler);
          this.get("sectionEventAggregator").bind("value:changed", this.valueChangedEventHandler, that);

          this.get("sectionEventAggregator").unbind("verifyRemotes", this.verifyRemotesEventHandler);
          this.get("sectionEventAggregator").bind("verifyRemotes", this.verifyRemotesEventHandler, that);

          window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, that);

          this.unbind("change:unavailable", this.unavailableChangedEventHandler);
          this.bind("change:unavailable", this.unavailableChangedEventHandler, this);
        },

        unavailableChangedEventHandler: function() {
          this.trigger("render:requested");
        },

        changeLoadedModelEventHandler: function() {
          if (this.get("loadedModel"))
            this.retrievePackages();
        },

        verifyRemotesEventHandler: function() {
          var interfaces = this.get("interfaces"),
            interfacesLength = interfaces ? interfaces.length : 0;
          var remotes = this.get("remotes"),
            remotesLength = remotes ? remotes.length : 0;
          var countInterface = 0;
          for (j = 0; j < interfacesLength; j++)
            countInterface+=interfaces[j].get("value");
          
          //se i remotes aumenteranno occorre fare i controlli per togliere le quantità.
          if(countInterface*remotes[0].get("maxValue")<remotes[0].get("value"))
            remotes[0].set("value",countInterface*remotes[0].get("maxValue"));
            
        },

        valueChangedEventHandler: function() {
          var interfacesAmount = 0,
            remotesAmount = 0;
          var interfaces = this.get("interfaces"),
            interfacesLength = interfaces ? interfaces.length : 0;
          var remotes = this.get("remotes"),
            remotesLength = remotes ? remotes.length : 0;

          for (i = 0; i < interfacesLength; i++)
            interfacesAmount += interfaces[i].get("value");

          for (i = 0; i < remotesLength; i++)
            remotesAmount += remotes[i].get("value");

          if (interfacesAmount > 0) {
            this.enableRemotes();
          } else {
            this.disableRemotes();
            remotesAmount = 0;
          }

          this.trigger("updateViews", [{
            name: "IDS_WAI2_424",
            amount: interfacesAmount
          }, {
            name: "IDS_WAI2_425",
            amount: remotesAmount
          }]);
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },

        enableInterfaces: function() {
          if (this.get("interfaces")) {
            var interfaces = this.get("interfaces"),
              interfacesLength = interfaces.length;

            for (var i = 0; i < interfacesLength; i++)
              interfaces[i].enable();
            this.valueChangedEventHandler();
          }
        },

        disableInterfaces: function() {
          if (this.get("interfaces")) {
            var interfaces = this.get("interfaces"),
              interfacesLength = interfaces.length;

            for (var i = 0; i < interfacesLength; i++)
              interfaces[i].disable();
            this.valueChangedEventHandler();
          }
        },

        enableRemotes: function() {
          if (this.get("remotes")) {
            var remotes = this.get("remotes"),
              remotesLength = remotes.length;

            for (var i = 0; i < remotesLength; i++)
              remotes[i].enable();
          }
        },

        disableRemotes: function() {
          if (this.get("remotes")) {
            var remotes = this.get("remotes"),
              remotesLength = remotes ? remotes.length : 0;

            for (var i = 0; i < remotesLength; i++) {
              remotes[i].set("value", 0);
              remotes[i].disable();
            }
          }
        },

        assignInterfaceValues: function(value) {
          var interfaces = this.get("interfaces"),
            interfacesLength = interfaces.length;

          for (var i = 0; i < interfacesLength; i++)
            interfaces[i].set("value", value);
        },

        assignRemoteValues: function(value) {
          var remotes = this.get("remotes"),
            remotesLength = remotes.length;

          for (var i = 0; i < remotesLength; i++)
            remotes[i].set("value", value);
        },

        retrievePackages: function() {
          var that = this;
          var productsToAdd = [];
          var currentModelToLoad = this.get("loadedModel");
          var sectionEventAggregator = this.get("sectionEventAggregator");

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(404, function(packagesData) {
              that.set("unavailable", false);
              var packages = packagesData.packages,
                packagesLength = packages.length;
              var getProducts = function(currentPackage) {
                BticinoS4B.Instances.Models.ApplicationModel.getProducts(currentPackage.packageClassId, function(productsData) {
                  var products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(productsData.products);
                  products = _.filter(products, function(product) {
                    return (product.mnemonic === 1);
                  }).splice(0, 1);

                  var productsLength = products ? products.length : 0;
                  var radioSystemModelAttributes;

                  for (var j = 0; j < 1; j++) {
                    productsToAdd = [];
                    radioSystemModelAttributes = {};
                    _.extend(radioSystemModelAttributes, currentPackage);
                    _.extend(radioSystemModelAttributes, products[j]);
                    _.extend(radioSystemModelAttributes, {
                      enabled: that.get("enabled")
                    });
                    _.extend(radioSystemModelAttributes, {
                      sectionEventAggregator: sectionEventAggregator
                    });
                    _.extend(radioSystemModelAttributes, {
                      minValue: 1,
                      maxValue: 2,
                      type: 'interfaces'
                    });
                    _.extend(radioSystemModelAttributes, {
                      infoQuote: "IDS_WGENTT_000017"
                    });
                    productsToAdd.push(new radioSystemModel(radioSystemModelAttributes));
                  }
                  var secondaryProducts = _.filter(productsData.products, function(product) {
                    return (product.mnemonic !== 1);
                  });

                  that.set("interfacesSecondaryProducts", secondaryProducts);
                  that.set("interfaces", productsToAdd);
                });
              };
              for (var i = 0; i < packagesLength; i++) {
                getProducts(packages[i]);
              }
            },
            function() {
              that.disableInterfaces();
              that.disableRemotes();
              that.set("unavailable", true);
            }
          );

          BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(405, function(packagesData) {
            var packages = packagesData.packages,
              packagesLength = packages ? packages.length : 0;
            var productsToAdd = [];
            var getProducts = function(currentPackage) {
              BticinoS4B.Instances.Models.ApplicationModel.getProducts(currentPackage.packageClassId, function(productsData) {
                var products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(productsData.products);

                products = _.filter(products, function(product) {
                  return (product.mnemonic === 1);
                }).splice(0, 1);

                var productsLength = products ? products.length : 0;
                var radioSystemModelAttributes;

                for (var j = 0; j < productsLength; j++)
                {
                  productsToAdd = [];
                  radioSystemModelAttributes = {};
                  _.extend(radioSystemModelAttributes, currentPackage);
                  _.extend(radioSystemModelAttributes, products[j]);
                  _.extend(radioSystemModelAttributes, {
                    enabled: that.get("enabled")
                  });
                  _.extend(radioSystemModelAttributes, {
                    sectionEventAggregator: sectionEventAggregator
                  });
                  _.extend(radioSystemModelAttributes, {
                    maxValue: 10,
                    type: 'remotes'
                  });
                  _.extend(radioSystemModelAttributes, {
                    infoQuote: "IDS_WGENTT_000018"
                  });
                  productsToAdd.push(new radioSystemModel(radioSystemModelAttributes));
                }

                var secondaryProducts = _.filter(productsData.products, function(product) {
                  return (product.mnemonic !== 1);
                });

                that.set("remotesSecondaryProducts", secondaryProducts);
                that.set("remotes", productsToAdd);
              });
            };
            for (var i = 0; i < packagesLength; i++) {
              getProducts(packages[i]);
            }
          });

          if (currentModelToLoad) {
            //Checking interfaces abilitation
            if (currentModelToLoad.interfaces[0].enabled) {
              BticinoS4B.Instances.Models.ApplicationModel.set("radioSystemPresent", true);
              window.BticinoS4B.eventAggregator.trigger("radioSystemPresent:changed", this);
              this.set("enabled", true);
              //this.set("interfaces", currentModelToLoad.interfaces[0]);
              this.assignInterfaceValues(currentModelToLoad.interfaces[0].value);
              this.enableInterfaces();
            } else {
              BticinoS4B.Instances.Models.ApplicationModel.set("radioSystemPresent", false);
              window.BticinoS4B.eventAggregator.trigger("radioSystemPresent:changed", this);
              this.disableInterfaces();
            }

            //Checking remotes abilitation
            if (currentModelToLoad.remotes[0].enabled){
              //this.set("remotes", currentModelToLoad.remotes[0]);
              this.assignRemoteValues(currentModelToLoad.remotes[0].value);
              this.set("enabled", true);
              this.enableRemotes();

            }
            else
              this.disableRemotes();
            this.trigger('render:requested');
            this.set("loadedModel", undefined);

          }
        },

        disableSection: function() {
          var that = this,
            i = 0;
          var interfaces = this.get("interfaces"),
            interfacesLength = interfaces.length;
          var remotes = this.get("remotes"),
            remotesLength = remotes.length;

          for (i = 0; i < interfacesLength; i++)
            interfaces[i].disable();

          for (i = 0; i < remotesLength; i++)
            remotes[i].disable();
        },

        enableSection: function() {
          var that = this,
            i = 0;
          var interfaces = this.get("interfaces"),
            interfacesLength = interfaces.length;
          var remotes = this.get("remotes"),
            remotesLength = remotes.length;

          for (i = 0; i < interfacesLength; i++)
            interfaces[i].enable();

          for (i = 0; i < remotesLength; i++)
            remotes[i].enable();
        },

        deliverModel: function() {
          var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            interfaces = this.get("interfaces"),
            remotes = this.get("remotes"),
            interfacesSecondaryProducts = this.get("interfacesSecondaryProducts"),
            remotesSecondaryProducts = this.get("remotesSecondaryProducts");
          var i = 0,
            j = 0;

          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.radioSystems = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.radioSystems = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.radioSystems = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.radioSystems = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.radioSystems = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.radioSystems = this;
              break;
          }

          BticinoS4B.Instances.Models.ApplicationModel.set("radioSystems", this);

          //Adding interfaces
          if (interfaces) {
            this.set("enabled", true);
            for (i = 0; i < interfaces.length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: interfaces[i].get("productCode"),
                productLabel: interfaces[i].get("productLabel"),
                packageClassId: interfaces[i].get("packageClassId"),
                packageClassLabel: interfaces[i].get("packageClassLabel"),
                quantity: interfaces[i].get("value"),
                price: interfaces[i].get("price"),
                isRadioInterface: true
              });
            }

            for (i = 0; i < interfacesSecondaryProducts.length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: interfacesSecondaryProducts[i].get("productCode"),
                productLabel: interfacesSecondaryProducts[i].get("productLabel"),
                packageClassId: interfacesSecondaryProducts[i].get("packageClassId"),
                packageClassLabel: interfacesSecondaryProducts[i].get("packageClassLabel"),
                quantity: interfacesSecondaryProducts[i].get("value"),
                price: interfacesSecondaryProducts[i].get("price")
              });
            }
          }

          //Adding remotes
          if (remotes) {
            this.set("enabled", true);
            for (i = 0; i < remotes.length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: remotes[i].get("productCode"),
                productLabel: remotes[i].get("productLabel"),
                packageClassId: remotes[i].get("packageClassId"),
                packageClassLabel: remotes[i].get("packageClassLabel"),
                quantity: remotes[i].get("value"),
                price: remotes[i].get("price"),
                isRemoteControl: true
              });
            }

            for (i = 0; i < remotesSecondaryProducts.length; i++) {
              dataProvider.addItems("externalItems", {
                productCode: remotesSecondaryProducts[i].get("productCode"),
                productLabel: remotesSecondaryProducts[i].get("productLabel"),
                packageClassId: remotesSecondaryProducts[i].get("packageClassId"),
                packageClassLabel: remotesSecondaryProducts[i].get("packageClassLabel"),
                quantity: remotesSecondaryProducts[i].get("value"),
                price: remotesSecondaryProducts[i].get("price")
              });
            }
          }
        },

        loadProject: function(model) {
          if (model.radioSystems) {
            this.set("loadedModel", model.radioSystems);
          }
        },

        deliverCurrent: function() {
          if (this.get("interfaces")) {
            var i = 0;
            var interfaces = this.get("interfaces");
            var remotes = this.get("remotes");
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
            var interfacesCurrentConsumption = 0;
            var remotesCurrentConsumption = 0;

            for (i = 0; i < interfaces.length; i++) {
              if ((interfaces[i].get("specialVars")) && (interfaces[i].get("specialVars") !== ""))
                interfacesCurrentConsumption = $.parseJSON(interfaces[i].get("specialVars")).currentConsumption * interfaces[i].get("value");

              if (interfacesCurrentConsumption < 0)
                consumptionIndicatorModel.addSupplyCurrent(interfacesCurrentConsumption);
              else
                consumptionIndicatorModel.addCurrentConsumption(interfacesCurrentConsumption);
            }

            for (i = 0; i < remotes.length; i++) {
              if ((remotes[i].get("specialVars")) && (remotes[i].get("specialVars") !== ""))
                remotesCurrentConsumption = $.parseJSON(remotes[i].get("specialVars")).currentConsumption * remotes[i].get("value");

              if (remotesCurrentConsumption < 0)
                consumptionIndicatorModel.addSupplyCurrent(remotesCurrentConsumption);
              else
                consumptionIndicatorModel.addCurrentConsumption(remotesCurrentConsumption);
            }
          }
        }
      })
    });

    // Required, return the module for AMD compliance
    return radioSystems;

  });